import { Controller } from '@hotwired/stimulus';

/**
 * AdpLocationMappingFormController
 *
 * Manages the ADP Location Mapping form:
 *   - Payroll Client ID: read-only preview of the selected Decisely Location's value
 *     until "Edit" is clicked. Refreshes when the location changes.
 *   - "Exclude this Company Code" checkbox: when checked, clears and disables the
 *     routing fields (Decisely Location, Payroll Client ID) and removes their
 *     `required` attribute so the form can be submitted without them.
 */
export default class extends Controller {
  static targets = [
    'groupLocationSelect',
    'payrollClientIdField',
    'editButton',
    'excludedCheckbox',
    'routingFields'
  ];

  static values = { payrollClientIds: Object };

  connect() {
    this.applyExcludedState();
  }

  groupLocationChanged() {
    if (!this.hasGroupLocationSelectTarget) return;

    const selectedId = this.groupLocationSelectTarget.value;
    const value = this.payrollClientIdsValue[selectedId] || '';
    this.payrollClientIdFieldTarget.value = value;
    this.disableField();
  }

  enableEdit(event) {
    event.preventDefault();
    this.payrollClientIdFieldTarget.disabled = false;
    this.payrollClientIdFieldTarget.focus();
    if (this.hasEditButtonTarget) this.editButtonTarget.style.display = 'none';
  }

  excludedChanged() {
    if (this.excludedCheckboxTarget.checked) {
      this.groupLocationSelectTarget.value = '';
      this.payrollClientIdFieldTarget.value = '';
    }
    this.applyExcludedState();
  }

  applyExcludedState() {
    if (!this.hasExcludedCheckboxTarget || !this.hasRoutingFieldsTarget) {
      this.disableField();
      return;
    }

    const excluded = this.excludedCheckboxTarget.checked;
    this.routingFieldsTarget.hidden = excluded;
    this.groupLocationSelectTarget.disabled = excluded;
    this.groupLocationSelectTarget.required = !excluded;

    if (excluded) {
      this.payrollClientIdFieldTarget.disabled = true;
    } else {
      this.disableField();
    }
  }

  disableField() {
    this.payrollClientIdFieldTarget.disabled = true;
    if (this.hasEditButtonTarget) this.editButtonTarget.style.display = '';
  }
}
